// ABOUTME: Provider for the sidebar open/closed state
// ABOUTME: Persists sidebar state to localStorage for user preference; the hook lives in useSidebarContext.ts

import type { ReactNode } from "react"
import React, { useMemo, useState } from "react"
import { STORAGE_KEYS } from "@shared/constants/storageKeys"
import { SidebarContext, type SidebarContextProps } from "./useSidebarContext"

export const SidebarProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(() => {
    const val = localStorage.getItem(STORAGE_KEYS.SIDEBAR_OPEN)
    if (val) {
      const parsed: unknown = JSON.parse(val)
      return typeof parsed === "boolean" ? parsed : false
    }
    return false
  })

  const value = useMemo<SidebarContextProps>(
    () => ({
      isSidebarOpen,
      toggleSidebar: () => {
        const next = !isSidebarOpen
        setIsSidebarOpen(next)
        localStorage.setItem(STORAGE_KEYS.SIDEBAR_OPEN, JSON.stringify(next))
      },
    }),
    [isSidebarOpen],
  )

  return <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>
}
